import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    cancelButtonLabel: 'Cancel',
    updateButtonLabel: 'Update',
    validationErrorMessage: 'There are form errors',
  },
})
